import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography, Grid, Box, Fade } from "@mui/material";
import { Link } from "react-router-dom";
import CustomButton from "../components/CustomButton";
// import IconButton from "@mui/material/IconButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ForumIcon from "@mui/icons-material/Forum";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LaptopIcon from "@mui/icons-material/Laptop";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import BarChartIcon from "@mui/icons-material/BarChart";
import EventNoteIcon from '@mui/icons-material/EventNote';
// import ApartmentIcon from "@mui/icons-material/Apartment";

import Projects from "../components/Projects";

export default function Home({ darkMode }) {
  // fade-in animation:
  const [showSubTitle, setShowsubTitle] = useState(false);
  // const [showImage, setShowImage] = useState(false);
  const [showText1, setShowText1] = useState(false);
  const [showText2, setShowText2] = useState(false);
  const [showText3, setShowText3] = useState(false);

  // setting fade-in-state to true (only once, when component renders):
  useEffect(() => {
    setTimeout(() => setShowsubTitle(true), 400);
    // setTimeout(() => setShowImage(true), 500);
    setTimeout(() => setShowText1(true), 900);
    setTimeout(() => setShowText2(true), 1100);
    setTimeout(() => setShowText3(true), 1400);
  }, []);

  // animation for revealing name:
  function useRevealOnScroll() {
    const ref = useRef(null);

    useEffect(() => {
      const el = ref.current;
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("animate");
            observer.disconnect(); // pokreni samo jednom
          }
        },
        { threshold: 0.4 },
      );

      observer.observe(el);
      return () => observer.disconnect();
    }, []);

    return ref;
  }

  const revealRef = useRevealOnScroll();

  // enable scrolling to the Projects-section from other pages, like Contact:
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#projects") {
      const el = document.getElementById("projects");
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  const projectCards = [
    {
      id: "apf",
      icon: BarChartIcon,
      title: "APF Case Management",
      desc: "full-stack internal business app",
      tech: "React, Express.js, Zustand, PostgreSQL",
    },
    {
      id: "project0",
      icon: ShoppingCartIcon,
      title: "SmartSpace Studio",
      desc: "full-stack demo e-commerce app",
      tech: "React, Redux Toolkit, Express.js, MySQL",
    },
    {
      id: "project00",
      icon: HolidayVillageIcon,
      title: "AdriaticResorts",
      desc: "full-stack vacation rental platform",
      tech: "React, Express.js",
    },
    {
      id: "project5",
      icon: EventNoteIcon,
      title: "Memo app",
      desc: "mobile note-taking app",
      tech: "React Native, Expo Router, SQLite",
    },
    {
      id: "project1",
      icon: ForumIcon,
      title: "Chat app",
      desc: "real-time chat application",
      tech: "React, Scaledrone Websocket",
    },
    {
      id: "project2",
      icon: HeadphonesIcon,
      title: "Music domain",
      desc: "music search platform",
      tech: "JavaScript, Spotify API, Express.js",
    },
    {
      id: "project3",
      icon: MenuBookIcon,
      title: "Tolkien page",
      desc: "website about J.R.R. Tolkien",
      tech: "JavaScript, OpenLibrary API",
    },
    {
      id: "project4",
      icon: LaptopIcon,
      title: "Developer portfolio",
      desc: "projects and skills overview",
      tech: "React, Material UI",
    },
  ];

  return (
    <Container id="home" sx={{ scrollMarginTop: "100px" }}>
      <Typography
        variant="h4"
        // className="flip-scale-2-hor-bottom"
        // style={{ animationDirection: "reverse" }}
        gutterBottom //
        sx={{
          animation:
            "scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
          animationDelay: "0s",
          mt: 8,
          mb: 1,
          textAlign: "center",
          fontSize: {
            xs: "1.8rem",
            sm: "1.8rem",
            md: "2rem",
            lg: "2.4rem",
          },
        }}
        // fontFamily={"TheSeasons-Regular, serif"}
        // fontFamily={"Mulish-Extralight"}
        fontFamily={"Cabin, sans-serif"}
        fontWeight="600"
        fontStyle="normal"
      >
        Hi, I'm{" "}
        <Box
          ref={revealRef}
          className="animated-text-reveal"
          data-text="Marina"
          component="span"
          // sx={{ color: "primary.title" }}
        >
          Marina
        </Box>
      </Typography>

      <Fade in={showSubTitle} timeout={600}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            className="scale-up-center"
            // className="animated-text-reveal"
            data-text="full-stack JS developer"
            sx={{
              color: "primary.title",
              mt: 4,
              mb: 2,
              fontFamily: "Cabin, sans-serif",
              fontWeight: "600",
              fontSize: {
                xs: "1.4rem",
                sm: "1.6rem",
                md: "1.8rem",
                lg: "2rem",
              },

              animation:
                "scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
              animationDelay: "0.2s",
            }}
          >
            full-stack JS developer
          </Typography>
          <Typography
            sx={{
              mt: 2,
              mb: 6,
              textAlign: "center",
              fontFamily: "Cabin, sans-serif",
              // fontSize: "1.4rem",
              fontSize: {
                xs: "1.2rem",
                sm: "1.2rem",
                md: "1.4rem",
                lg: "1.6rem",
              },
              animation:
                "scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
              animationDelay: "0.4s",
            }}
          >
            turning business needs into practical solutions
          </Typography>

          {/* <Typography
            sx={{
              mt: 2,
              mb: 8,
              textAlign: "center",
              fontFamily: "Cabin, sans-serif",
              // fontSize: "1.4rem",
              fontSize: {
                xs: "1.2rem",
                sm: "1.2rem",
                md: "1.4rem",
                lg: "1.6rem",
              },
              animation:
                "scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
              animationDelay: "0.6s",
            }}
          >
            API-driven interfaces with React and modern JavaScript.
          </Typography> */}
        </Box>
      </Fade>

      {/* container for both main illustration (left) and text boxes (right): */}
      <Grid
        container
        sx={{
          display: "grid",
          // transform: "none",
          gridTemplateColumns: {
            xs: "1fr",
            lg: "1fr 1fr",
          },
          columnGap: 4,
          rowGap: 4,
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
        }}
      >
        {/* LEFT SIDE — IMAGE */}
        {/* <Fade in={showImage} timeout={600}> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            transition: "transform 0.6s ease, border 1s ease",
            "&:hover": {
              transform: "scale(1.02)",
              // border: "1.3px solid rgba(76, 201, 254, 0.4)",
            },
          }}
        >
          <Box
            component="img"
            src={darkMode ? "/Dev-port3.png" : "/Dev-port7.png"}
            alt="code"
            sx={{
              width: "100%",
              // maxWidth: "500px",
              maxWidth: { xs: "100%", sm: "80%", md: "50%", lg: "100%" },
              borderRadius: "16px",

              boxShadow:
                "4px 4px 8px 0 rgba(76, 201, 254, 0.2), 0 6px 20px 0 rgba(76, 201, 254, 0.19)",
              display: "block",
              // animation: "flip-scale-up-hor 1.2s linear reverse both",

              animation: "hero-image-flip-strong 0.9s ease-out both 0.5s",
            }}
          />
        </Box>
        {/* </Fade> */}

        {/* RIGHT SIDE — 2 TEXTBOXES */}
        <Box
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{
            // maxWidth: { xs: "80%", sm: "80%", md: "500px" },

            margin: "0 auto",
            wordWrap: "break-word",
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* TEXTBOX 1 */}
          <Fade in={showText1} timeout={600}>
            <Box
              sx={{
                // width: 500,
                width: "100%",
                maxWidth: { xs: "100%", sm: "100%", md: "100%" },
                // height: 226,
                backgroundColor: !darkMode && "rgba(237, 250, 254, 0.6)",
                borderRadius: 4,
                border: "1px solid transparent",
                // "&:hover": {
                //   border: "1.3px solid rgba(76, 201, 254, 0.4)",
                // },
                p: 3.7,
                pl: {
                  xs: 3,
                  md: 5,
                },
                pr: {
                  xs: 3,
                  md: 5,
                },

                boxShadow:
                  "2px 2px 2px 0 rgba(76, 201, 254, 0.2), 0 6px 10px 0 rgba(76, 201, 254, 0.19)",
                transition: "transform 0.6s ease",
                "&:hover": {
                  // transform: "scale(1.02)",
                  border: "1.3px solid rgba(76, 201, 254, 0.4)",
                },
              }}
            >
              <Typography
                color="text.secondary"
                sx={{
                  marginBottom: 1,
                  fontFamily: "Mulish-Extralight, sans-serif",
                  fontSize: {
                    xs: "1rem",
                    md: "1.2rem",
                  },
                  textAlign: "center",
                }}
              > 
                Analysing business needs and designing solutions with
                focus on process improvement and automation. From requirements
                gathering to full-stack development,
                integration and delivery.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 3,
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <CustomButton
                  component={Link}
                  to="/contact/#aboutme"
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    fontFamily: "Cabin, sans-serif",
                    fontWeight: "500",
                    letterSpacing: "0.02em",
                    // letterSpacing: "0.07em",
                    fontSize: "1rem",
                    textTransform: "none",
                    transition: "transform 0.25s ease, border 0.25s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  ABOUT ME
                </CustomButton>

                <CustomButton
                  component={Link}
                  to="/contact#contactme"
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    fontFamily: "Cabin, sans-serif",
                    fontWeight: "500",
                    letterSpacing: "0.02em",
                    // letterSpacing: "0.07em",
                    fontSize: "1rem",
                    textTransform: "none",
                    transition: "transform 0.25s ease, border 0.25s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  CONTACT ME
                </CustomButton>
              </Box>
            </Box>
          </Fade>

          {/* TEXTBOX 2 */}
          <Fade in={showText2} timeout={600}>
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: "100%", md: "100%" },
                // height: 226,
                backgroundColor: !darkMode && "rgba(237, 250, 254, 0.6)",
                borderRadius: 4,
                border: "1px solid transparent",
                // "&:hover": {
                //   border: "1.3px solid rgba(76, 201, 254, 0.4)",
                // },
                p: 3.7,
                pl: {
                  xs: 4,
                  md: 5,
                },
                pr: {
                  xs: 4,
                  md: 5,
                },
                boxShadow:
                  "2px 2px 2px 0 rgba(76, 201, 254, 0.2), 0 6px 10px 0 rgba(76, 201, 254, 0.19)",
                transition: "transform 0.6s ease, border 1s ease",
                "&:hover": {
                  // transform: "scale(1.02)",
                  border: "1.3px solid rgba(76, 201, 254, 0.4)",
                },
              }}
            >
              <Typography
                color="text.secondary"
                sx={{
                  marginBottom: 1,
                  fontFamily: "Mulish-Extralight, sans-serif",
                  fontSize: {
                    xs: "1rem",
                    md: "1.2rem",
                  },
                  textAlign: "center",
                }}
              >
                Building full-stack applications and automation solutions with:{" "}
                
                <strong>React</strong>, <strong>TypeScript</strong>,{" "}
                <strong>Node.js</strong>, <strong>Express.js</strong>,{" "}
                <strong>PostgreSQL</strong>, <strong>MySQL</strong>,{" "}
                <strong>Playwright</strong>, <strong>Next.js</strong>,{" "}
                <strong>React Router</strong>, <strong>TanStack Query</strong>,{" "}
                <strong>Redux</strong>, <strong>Jest</strong>,{" "}
                <strong>Vite</strong>, <strong>SCSS</strong> and{" "}
                <strong>Material UI</strong>. 
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 3,
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <CustomButton
                  component={Link}
                  to="/contact#skillsicon"
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    // fontFamily: "TheSeasons-Regular, serif",
                    // fontFamily: "Mulish-Extralight, sans-serif",
                    // letterSpacing: "0.07em",
                    fontFamily: "Cabin, sans-serif",
                    fontWeight: "500",
                    letterSpacing: "0.02em",
                    fontSize: "1rem",
                    textTransform: "none",
                    display: "flex",
                    textAlign: "center",
                    transition: "transform 0.25s ease, border 0.25s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  SKILLS AND TECHNOLOGIES
                </CustomButton>
              </Box>
            </Box>
          </Fade>
        </Box>
      </Grid>

      {/* TEXTBOX 3 - below the picture and 2 smaller textboxes */}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mt: {
            xs: 6,
            md: 10,
          },
        }}
      >
        <Fade in={showText3} timeout={600}>
          <Box
            sx={{
              width: "100%",
              backgroundColor: !darkMode && "rgba(237, 250, 254, 0.6)",
              borderRadius: 4,
              border: "1px solid transparent",
              // "&:hover": {
              //   border: "1.3px solid rgba(76, 201, 254, 0.4)",
              // },
              p: 3.7,
              pl: { xs: 2, sm: 5 },
              pr: { xs: 2, sm: 5 },
              boxShadow:
                "2px 2px 2px 0 rgba(76, 201, 254, 0.2), 0 6px 10px 0 rgba(76, 201, 254, 0.19)",
              transition: "transform 0.6s ease, border 1s ease",
              "&:hover": {
                // transform: "scale(1.02)",
                border: "1.3px solid rgba(76, 201, 254, 0.4)",
              },
            }}
          >
            <Typography
              color="text.secondary"
              sx={{
                marginBottom: 3,
                // fontFamily: "Mulish-Extralight, sans-serif",
                fontFamily: "Cabin, sans-serif",
                fontSize: "1.6rem",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              Check out my projects:
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr",
                "@media (min-width: 461px)": {
                  gridTemplateColumns: "repeat(2, 1fr)",
                },
                "@media (min-width: 726px)": {
                  gridTemplateColumns: "repeat(3, 1fr)",
                },
                "@media (min-width: 900px)": {
                  gridTemplateColumns: "repeat(4, 1fr)",
                },
                gap: { xs: 2, md: 3 },
              }}
            >
              {projectCards.map((project) => {
                const Icon = project.icon;
                return (
                  <Box
                    key={project.id}
                    component="a"
                    href={`#${project.id}`}
                    sx={{
                      textDecoration: "none",
                      cursor: "pointer",
                      aspectRatio: "1 / 1",
                      minWidth: 0,
                      minHeight: 0,
                      width: "100%",
                      overflow: "hidden",
                      containerType: "inline-size",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      p: 1.5,
                      borderRadius: 3,
                      border: "1px solid transparent",
                      backgroundColor: darkMode
                        ? "rgba(255, 255, 255, 0.04)"
                        : "rgba(2, 64, 134, 0.05)",
                      transition:
                        "transform 0.25s ease, border 0.25s ease, background-color 0.25s ease",
                      "&:hover": {
                        border: "1.3px solid rgba(76, 201, 254, 0.4)",
                        backgroundColor: darkMode
                          ? "rgba(255, 255, 255, 0.08)"
                          : "rgba(2, 64, 134, 0.09)",
                      },
                      "&:hover .project-tech-hover": {
                        opacity: 1,
                        maxHeight: "3em",
                        mt: 0.5,
                      },
                    }}
                  >
                    <Icon
                      sx={{
                        fontSize: "clamp(1.3rem, 15cqi, 2.4rem)",
                        mb: 1,
                        color: darkMode ? "white" : "text.secondary",
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Mulish-Extralight, sans-serif",
                        fontWeight: 600,
                        fontSize: "clamp(0.9rem, 10cqi, 1.3rem)",
                        color: "#1EA0D9",
                        overflowWrap: "break-word",
                        wordBreak: "normal",
                        maxWidth: "100%",
                      }}
                    >
                      {project.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Mulish-Extralight, sans-serif",
                        fontSize: "clamp(0.8rem, 8.5cqi, 1.1rem)",
                        color: darkMode ? "#fff" : "rgba(2, 64, 134, 0.88)",
                        overflowWrap: "break-word",
                        wordBreak: "normal",
                        maxWidth: "100%",
                      }}
                    >
                      {project.desc}
                    </Typography>
                    <Typography
                      className="project-tech-hover"
                      sx={{
                        fontFamily: "Mulish-Extralight, sans-serif",
                        fontSize: "clamp(0.7rem, 7cqi, 0.95rem)",
                        color: "#1EA0D9",
                        opacity: 0,
                        maxHeight: 0,
                        overflow: "hidden",
                        transition: "opacity 0.25s ease, max-height 0.25s ease",
                        overflowWrap: "break-word",
                        wordBreak: "normal",
                        maxWidth: "100%",
                      }}
                    >
                      {project.tech}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3,
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <CustomButton
                component={Link}
                to="/#projects"
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  // fontFamily: "TheSeasons-Regular, serif",
                  fontFamily: "Cabin, sans-serif",
                  letterSpacing: "0.02em",
                  fontSize: "1rem",
                  textTransform: "none",
                  transition: "transform 0.25s ease, border 0.25s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
              >
                PROJECTS
              </CustomButton>

              <CustomButton
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  // fontFamily: "Mulish-Extralight, sans-serif",
                  fontFamily: "Cabin, sans-serif",
                  letterSpacing: "0.02em",
                  fontSize: "1rem",
                  textTransform: "none",
                  transition: "transform 0.25s ease, border 0.25s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
                href="https://github.com/Flame787"
                target="_blank"
                rel="noopener noreferrer"
              >
                GITHUB <OpenInNewIcon sx={{ ml: 0.7, fontSize: "1rem" }} />
              </CustomButton>
            </Box>
          </Box>
        </Fade>
      </Box>

      {/* Projects section */}
      <Projects />
    </Container>
  );
}
